<div class="user-wrapper">
    @if(shouldShowBanner) {
        <div class="user-banner">
            <img class="img-header" src="{{ mediaServer }}/zeta/user/header.png">
        </div>
    }
    <div class="user-body" [class.full-page]="!shouldShowBanner">
        <router-outlet></router-outlet>
    </div>
</div>